var map = {
	"./components/clientes/clientes.module": [
		"./src/app/components/clientes/clientes.module.ts",
		"components-clientes-clientes-module"
	],
	"./components/comunion/comunion.module": [
		"./src/app/components/comunion/comunion.module.ts",
		"components-comunion-comunion-module"
	],
	"./components/confirmacion/confirmacion.module": [
		"./src/app/components/confirmacion/confirmacion.module.ts",
		"components-confirmacion-confirmacion-module"
	],
	"./components/contactenos/contactenos.module": [
		"./src/app/components/contactenos/contactenos.module.ts",
		"components-contactenos-contactenos-module"
	],
	"./components/corporativos/corporativos.module": [
		"./src/app/components/corporativos/corporativos.module.ts",
		"components-corporativos-corporativos-module"
	],
	"./components/cumple15/cumple15.module": [
		"./src/app/components/cumple15/cumple15.module.ts",
		"components-cumple15-cumple15-module"
	],
	"./components/drone/drone.module": [
		"./src/app/components/drone/drone.module.ts",
		"components-drone-drone-module"
	],
	"./components/foto-cabina/foto-cabina.module": [
		"./src/app/components/foto-cabina/foto-cabina.module.ts",
		"components-foto-cabina-foto-cabina-module"
	],
	"./components/kinder/kinder.module": [
		"./src/app/components/kinder/kinder.module.ts",
		"components-kinder-kinder-module"
	],
	"./components/matine/matine.module": [
		"./src/app/components/matine/matine.module.ts",
		"components-matine-matine-module"
	],
	"./components/matrimonio/matrimonio.module": [
		"./src/app/components/matrimonio/matrimonio.module.ts",
		"components-matrimonio-matrimonio-module"
	],
	"./components/merchandising/merchandising.module": [
		"./src/app/components/merchandising/merchandising.module.ts",
		"components-merchandising-merchandising-module"
	],
	"./components/productos/productos.module": [
		"./src/app/components/productos/productos.module.ts",
		"components-productos-productos-module"
	],
	"./components/promocion5to/promocion5to.module": [
		"./src/app/components/promocion5to/promocion5to.module.ts",
		"components-promocion5to-promocion5to-module"
	],
	"./components/promocion6to/promocion6to.module": [
		"./src/app/components/promocion6to/promocion6to.module.ts",
		"components-promocion6to-promocion6to-module"
	],
	"./components/quienes-somos/quienes-somos.module": [
		"./src/app/components/quienes-somos/quienes-somos.module.ts",
		"components-quienes-somos-quienes-somos-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;